import { JSEncrypt } from 'jsencrypt'

// 密钥对生成 http://web.chacuo.net/netrsakeypair
// 公钥
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDLHT1w3FjddFKFu90pO6NE46a0BSS0DAGGGDVuveLfRTc/s3XWOxurnwkLIfeVG+JYkTYGOBEgudIcRSE492Q3fyDPZx0HnHNCwQC/cWUMOPiSOgNEFiQIfuJzaBdF6D2wlfbkm4PXgPkm4Ax8/SyCICKCaUQTSRH6XsrUBwdkjwIDAQAB'

// 私钥
const privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAMsdPXDcWN10UoW73Sk7o0TjprQFJLQMAYYYNW694t9FNz+zddY7G6ufCQsh95Ub4liRNgY4ESC50hxFITj3ZDd/IM9nHQecc0LBAL9xZQw4+JI6A0QWJAh+4nNoF0XoPbCV9uSbg9eA+SbgDHz9LIIgIoJpRBNJEfpeytQHB2SPAgMBAAECgYEAtnYA8LbxGZdaXorCBT1u0P7UjVklfJxgbg6nSWFJQhrSo+XaEGYu2EBYhmiwGYHgFoH0Dygksspa5kxvqNYMbniMyZsCWZJveRpQwRbyHXpexCNqQ575LlqplzZ5g4gpqCxHD/qhwJ4o1gAp0N4qyOZyxokPoDAxhzzNmu2scIECQQDmptiNm2lZQldYa1AR2HqDm5gzTCmjXLxz/LP7dltCMk1Apyof5VrPIcQ/4rNAyH8dUV8g2rzn10KFm3CQKoRPAkEA4W+nVjMY/+5EDOiCJXaJ41UzGg8sq9V/T2oe3Inp8PT4iclFsA6Sv/eWoKI3GwH9ugyAYJMTehuDOAybeEHLwQJALHim8EayvT8JUEcAnTA8DvwFEH7y2EidHU/v8+ASIGVKd9jDSnsSUzWTfS3cmfUObTyvNsp1+c2LSe96eJF6CQJACbULGZUdsHeMCppAcGiIS3exuZ+JpuSMlNjW91wg7LU/tn8qNwiJnSaGH+icQtd1G3vKU15B6nIg1lsEnssGgQJAGs87MMRcsqBnQjn4Uvo9jDq+pIl64k2tlpqP6vWj0U0vZZJJir371/VkFlwqitxveJOlayZWvOFilAs28Y38fw=='

// new一个JSEncrypt对象
const crypt = new JSEncrypt()
// setKey统一添加公钥和私人钥
crypt.setKey(publicKey)
crypt.setKey(privateKey)
// 或者   setPublicKey添加公钥 setPrivateKey添加私人钥 建议先添加公钥再添加私钥 不然解密不出来

crypt.setPublicKey(publicKey)
crypt.setPrivateKey(privateKey)

// 加密
export function encrypt(txt) {
  return crypt.encrypt(txt)
}

// 解密
export function decrypt(msg) {
  return crypt.decrypt(msg)
}
